/**
 * Warstwa API: BAZA WIEDZY OD NOWA (polecenie właściciela 2026-09-30 — adres z tematu, obowiązek zapoznania, procedury w bazie).
 *
 * Trasy backendu (KnowledgeBaseController + partiale .Zapoznanie / .Procedury):
 *  - `GET  api/KnowledgeBase/by-slug/{slug}` — strona /baza-wiedzy/:slug; liczba = stary link po Id (/baza-wiedzy/8), potem bieżący
 *    adres, potem stary adres po zmianie tytułu; DTO niesie kanoniczny adres (front podmienia pasek); 404 zamiast 403.
 *  - `GET  api/KnowledgeBase/moje-do-zapoznania` — licznik „Do zapoznania”.
 *  - `POST api/KnowledgeBase/{id}/zapoznanie` — `{ odciskTresci, oswiadczenie: true }`; 409 = treść zmieniła się w trakcie czytania.
 *  - `GET  api/KnowledgeBase/{id}/zapoznanie/rejestr` i `POST …/przypomnij` — redaktor (WikiManagePolicy).
 *  - `GET  api/KnowledgeBase/procedury-do-publikacji` — „Dodaj z procedur” (opublikowane, obowiązujące polityki).
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js; nazwy unikalne w całej aplikacji (attachApiModules pilnuje kolizji).
 */
export function attach(api) {
    return {
        getKnowledgeBaseArticleBySlug: (slug) => api.get(`/KnowledgeBase/by-slug/${encodeURIComponent(String(slug ?? ""))}`),
        getMojeDoZapoznaniaKb: () => api.get("/KnowledgeBase/moje-do-zapoznania"),
        getMojeZapoznanieKb: (articleId) => api.get(`/KnowledgeBase/${articleId}/zapoznanie`),
        potwierdzZapoznanieKb: (articleId, dane) => api.post(`/KnowledgeBase/${articleId}/zapoznanie`, dane),
        getRejestrZapoznaniaKb: (articleId) => api.get(`/KnowledgeBase/${articleId}/zapoznanie/rejestr`),
        przypomnijZapoznanieKb: (articleId) => api.post(`/KnowledgeBase/${articleId}/zapoznanie/przypomnij`),
        getProceduryDoPublikacjiKb: () => api.get("/KnowledgeBase/procedury-do-publikacji"),
    };
}
